export interface IRfFeedToRim {
    radioUnitIndex: string;
    rfFeedIndex: string;
    radioInputModuleId1: string;
    radioInputModuleId2: string;
    radioInputModuleId1Enable: string;
    radioInputModuleId2Enable: string;
  }
  
export let initalRfFeedToRim : IRfFeedToRim = {
  
    radioUnitIndex: "",
    rfFeedIndex: "1",
    radioInputModuleId1:"1",
    radioInputModuleId2: "2",
    radioInputModuleId1Enable: "true",
    radioInputModuleId2Enable: "true",
  }